import {DI_TOKENS} from '@/di/di.tokens';
import {AnalyticsClickerMenuButtonType} from '@/services/TrackingService/TrackingService.constants';
import {NavigationClickerModalType} from '@/stores/NavigationClickerModalStore/NavigationClickerModalStore.constants';

import {injected} from 'brandi';

import {TrackingService} from '@/services/TrackingService/TrackingService';
import {NavigationClickerModalStore} from '@/stores/NavigationClickerModalStore/NavigationClickerModalStore';

export class NavigationClickerModalService {
  constructor(private readonly store: NavigationClickerModalStore, private readonly trackingService: TrackingService) {}

  public setCurrentModalTypeGifts = (): void => {
    this.store.setCurrentModalType(NavigationClickerModalType.Gifts);
    this.trackingService.trackClickToClickerMenuButton(AnalyticsClickerMenuButtonType.Gifts);
  };

  public setCurrentModalTypeGiftsGameFinished = (): void => {
    this.store.setCurrentModalType(NavigationClickerModalType.GiftsGameFinished);
  };

  public setCurrentModalTypeGiftsGameMocks = (): void => {
    this.store.setCurrentModalType(NavigationClickerModalType.GiftsGameMocks);
  };

  public setCurrentModalTypeImprovements = (): void => {
    this.store.setCurrentModalType(NavigationClickerModalType.Improvements);
    this.trackingService.trackClickToClickerMenuButton(AnalyticsClickerMenuButtonType.Upgrades);
  };

  public setCurrentModalTypeLeaderboard = (): void => {
    this.store.setCurrentModalType(NavigationClickerModalType.Leaderboard);
    this.trackingService.trackClickToClickerMenuButton(AnalyticsClickerMenuButtonType.League);
  };

  public setCurrentModalTypeLeaderboardGameFinished = (): void => {
    this.store.setCurrentModalType(NavigationClickerModalType.Leaderboard);
    this.store.setCurrentModalType(NavigationClickerModalType.LeaderboardGameFinished);
  };

  public setCurrentModalTypeTasks = (): void => {
    this.store.setCurrentModalType(NavigationClickerModalType.Tasks);
    this.trackingService.trackClickToClickerMenuButton(AnalyticsClickerMenuButtonType.Tasks);
  };

  public setCurrentModalTypeDaily = (): void => {
    this.store.setCurrentModalType(NavigationClickerModalType.Daily);
    this.trackingService.trackClickToClickerMenuButton(AnalyticsClickerMenuButtonType.Minigame);
  };

  public setCurrentModalTypeFaq = (): void => {
    this.store.setCurrentModalType(NavigationClickerModalType.FAQ);
  };

  public setCurrentModalTypeGameStatistics = (): void => {
    this.store.setCurrentModalType(NavigationClickerModalType.GameStatistics);
  };

  public setCurrentModalTypeGameStatisticsMocks = (): void => {
    this.store.setCurrentModalType(NavigationClickerModalType.GameStatisticsMocks);
  };

  public setCurrentModalTypeBeforeResultsInfo = (): void => {
    this.store.setCurrentModalType(NavigationClickerModalType.BeforeResultsInfo);
  };

  public setCurrentModalTypeWinners = (): void => {
    this.store.setCurrentModalType(NavigationClickerModalType.Winners);
  };

  public setCurrentModalTypeSettings = (): void => {
    const currentModalType = this.store.getCurrentModalType();

    if (currentModalType !== NavigationClickerModalType.Settings) {
      this.store.setPrevModalType(this.store.getCurrentModalType());
    } else {
      this.navigateToPrevModal();
      return;
    }

    this.store.setCurrentModalType(NavigationClickerModalType.Settings);
    this.trackingService.trackClickToClickerMenuButton(AnalyticsClickerMenuButtonType.Settings);
  };

  public navigateToPrevModal = (): void => {
    this.store.setCurrentModalType(this.store.getPrevModalType());
  };

  public clearCurrentModalType = (): void => {
    this.store.setPrevModalType(this.store.getCurrentModalType());
    this.store.setCurrentModalType(null);
  };
}

injected(NavigationClickerModalService, DI_TOKENS.navigationClickerModalStore, DI_TOKENS.trackingService);
